import React from "react";
import { useTranslation } from "react-i18next";
import { TableCell, TableRow, Chip } from "@mui/material";
import "./style.scss";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
const ClientKeyRow = ({ row }) => {
	const { t } = useTranslation();
	let rowData = [];

	for (const property in row) {
		if (property === "id") continue;

		if (property === "firstName" || property === "displayName") {
			rowData.push(
				<TableCell
					style={{ wordBreak: "break-word" }}
					key={`${property}-${row[property]}`}
				>
					<div
						style={{
							display: "flex",
							justifyItems: "center",
							alignItems: "center",
							gap: 4,
						}}
					>
						{row.isAdmin && (
							<HtmlTooltip
								title={t("message.adminNoLicense")}
								placement="top"
							>
								<Chip
									size="small"
									color="primary"
									label={t("label.admin")}
									sx={(theme) => ({
										background: "#cae8fa",
										borderRadius: 4,
										padding: 1.5,
										paddingLeft: 0.5,
										paddingRight: 0.5,
										color: "blue",
										cursor: "pointer",
										"&:hover": { background: "#ade0ff" },
									})}
									avatar={
										<ShieldOutlinedIcon
											style={{
												background: "none",
												height: 15,
												width: 15,
												color: "blue",
											}}
										/>
									}
								/>
							</HtmlTooltip>
						)}
						{row.isRegionalPartner && (
							<HtmlTooltip
								title={t("message.regionalPartnerNoLicense")}
								placement="top"
							>
								<Chip
									size="small"
									label={t("label.regionalPartner")}
									sx={{
										background: "#fae8ca",
										borderRadius: 4,
										padding: 1.5,
										paddingLeft: 0.5,
										paddingRight: 0.5,
										color: "#b36b00",
										cursor: "pointer",
										"&:hover": { background: "#ffe0ad" },
									}}
									avatar={
										<HandshakeOutlinedIcon
											style={{
												background: "none",
												height: 15,
												width: 15,
												color: "#b36b00",
											}}
										/>
									}
								/>
							</HtmlTooltip>
						)}
						<p className="max-two-line">{row[property]}</p>
					</div>
				</TableCell>
			);
			continue;
		}

		if (property !== "isAdmin" && property !== "isRegionalPartner") {
			if (property === "application" || property === "email") {
				rowData.push(
					<TableCell
						style={{ wordBreak: "break-word" }}
						key={`${property}-${row[property]}`}
					>
						<HtmlTooltip title={row.email} placement="top">
							<p className="max-two-line">{row[property]}</p>
						</HtmlTooltip>
					</TableCell>
				);
			} else {
				rowData.push(
					<TableCell
						className="white-space-nowrap"
						key={`${property}-${row[property]}`}
					>
						{row[property]}
					</TableCell>
				);
			}
		}
	}

	return <TableRow>{rowData}</TableRow>;
};

export default ClientKeyRow;
